<template>
    <div class="dashboard-container">
        <side-bar />
        <div class="main-content">
            <div class="container">
                <!--Breadcrumbs and title embedded within below data page-->
                <distributor-breadcrumbs />
            </div>
            <div class="tabs">
                <div class="tab-header">
                    <button class="tab-button" @click="activeTab = 'bots'" :class="{ active: activeTab === 'bots' }">AI
                        Agents</button>
                    <!-- <button class="tab-button" @click="activeTab = 'history'"
                        :class="{ active: activeTab === 'history' }">Conversation History</button>
                    <button class="tab-button" @click="activeTab = 'logs'"
                        :class="{ active: activeTab === 'logs' }">Call Logs</button> -->
                    <button class="tab-button" @click="activeTab = 'profile'"
                        :class="{ active: activeTab === 'profile' }">Profile</button>
                </div>
                <div class="tab-content">
                    <div v-if="activeTab === 'bots'">
                        <div class="container">
                            <DistiBotTiles />
                        </div>
                    </div>
                    <div v-if="activeTab === 'history'">
                        <!-- Content for History tab -->
                    </div>
                    <div v-if="activeTab === 'logs'">
                        <!-- Content for Documents tab -->
                    </div>
                    <div v-if="activeTab === 'profile'">
                        <div class="container">
                            <!-- Profile content goes here -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SideBar from './SideBar.vue'
import DistiBotTiles from '../vuetify/DistiBotsTiles.vue'
import DistributorBreadcrumbs from '@/components/Distributor/DistributorBreadcrumbs.vue'

export default {
    name: 'DistiCustomerDetails',
    components: {
        SideBar,
        DistiBotTiles,
        DistributorBreadcrumbs
    },
    data() {
        return {
            activeTab: 'bots' // Default active tab
        }
    },
    created() {
        // Reset bot details
        localStorage.removeItem('botName');
        localStorage.removeItem('botDisplayName');
        localStorage.removeItem('botID');
        localStorage.removeItem('botType');
        localStorage.removeItem('botDID');
        localStorage.removeItem('campaignName');
    },
}
</script>